<template>
  <footer class="site__footer">
    <FooterLogo />
  </footer>
</template>

<script>
import FooterLogo from '@/components/footer-logo';

export default {
  components: {
    FooterLogo,
  },

  props: {
    isEnabled: Boolean,
  },
};
</script>

<style lang="scss">
.site__footer {
  bottom: 0;
  left: 0;
  padding-bottom: 15px;
  position: absolute;
  width: 100%;
  text-align: center;
}
</style>
